import React, { FC } from 'react'

import { PageContent } from 'common'
import { PrivacyPolicyButton } from 'components/privacy-policy-button'

import { PrivacyPolicyMenuContainer } from '../styles/PrivacyPolicy.styles'
import { TPrivacyPolicyView } from '../types/PrivacyPolicy.types'

export const PrivacyPolicyView: FC<TPrivacyPolicyView> = ({ termSections }) => (
  <PageContent>
    <PrivacyPolicyMenuContainer>
      {termSections?.map(({ onClick, versionId, description, icon }) => (
        <PrivacyPolicyButton
          key={versionId}
          icon={icon} // "core/files/ic_file_pdf"
          name={description}
          onClickHandler={onClick}
        />
      ))}
    </PrivacyPolicyMenuContainer>
  </PageContent>
)
